import { BiEnvelope } from "react-icons/bi";
import "./Contact.css"
const Contacts = () => {
  return (
    <div className="contact-page-main">
      <div
        className="build-by"
      >
        built by suryansh malik
      </div>
      <div className="pages-inner-content">
        <div
          data-aos="fade-up"
          data-aos-offset="0"
          data-aos-delay="0"
          data-aos-duration="1200"
          data-aos-easing="ease-out"
          className="pages-heading-div"
        >
          <BiEnvelope className="pages-page-icon" />
          <span className="pages-introduce">Contact</span>
        </div>
        <div className="contact-page-middle-content">
          <div className="contact-middle-content">
            <div
              data-aos="fade-up"
              data-aos-offset="0"
              data-aos-delay="0"
              data-aos-duration="1200"
              data-aos-easing="ease-out"
              className="contact-heading"
            >
              get in <span className="colored-heading">touch</span>
            </div>
            <p
              data-aos="fade-up"
              data-aos-offset="0"
              data-aos-delay="0"
              data-aos-duration="1200"
              data-aos-easing="ease-out"
              className="contact-description-para"
            >
              Although I’m currently looking for any new opportunities, my inbox
              is always open. Whether you have a question or just want to say
              hi, I’ll try my best to get back to you!
            </p>
            <a
              data-aos="fade-up"
              data-aos-offset="0"
              data-aos-delay="0"
              data-aos-duration="1200"
              data-aos-easing="ease-out"
              // href="https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=suryanshmalik111@gmail.com&body=my-text"
              href="mailto:suryanshmalik111@gmail.com"
              target="_blank"
              className="say-hello-button"
            >
              say hello
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Contacts;
